import { render, staticRenderFns } from "./BonusList.vue?vue&type=template&id=3deff16a&scoped=true"
import script from "./BonusList.vue?vue&type=script&lang=js"
export * from "./BonusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deff16a",
  null
  
)

export default component.exports